const comments = [
  {
    name: '追剧达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20avatar%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20solid%20warm%20gray%20background%2C%20professional%20headshot%20style%2C%20soft%20lighting&width=80&height=80&seq=avatar-01-user&orientation=squarish',
    time: '2 小时前',
    content: '用了悟空影视快一年了，真心推荐！资源更新速度无敌，基本上热门剧当天就能看。画质也很清晰，手机上看着完全不卡。关键是免费还不用注册，太良心了。',
    score: 5,
  },
  {
    name: '电影爱好者阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20in%20his%2020s%20portrait%20avatar%2C%20confident%20expression%2C%20modern%20casual%20look%2C%20clean%20solid%20light%20beige%20background%2C%20professional%20headshot%20lighting&width=80&height=80&seq=avatar-02-user&orientation=squarish',
    time: '5 小时前',
    content: '作为一个电影迷，这里的老片库真的让我惊喜。很多小时候在电视上看过的经典电影居然都能找到，画质修复得也不错。周末就喜欢窝在家里一部接一部看。',
    score: 5,
  },
  {
    name: '宝妈莉莉安',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20avatar%2C%20warm%20gentle%20smile%2C%20modern%20minimal%20style%2C%20clean%20solid%20warm%20cream%20background%2C%20soft%20professional%20headshot&width=80&height=80&seq=avatar-03-user&orientation=squarish',
    time: '1 天前',
    content: '带娃之余追剧全靠悟空影视了。综艺更新很及时，还能找到很多适合孩子看的动画片。不用安装任何软件，直接在浏览器打开就能看，对手机内存焦虑的我来说简直完美。',
    score: 4,
  },
  {
    name: '影视博主老张',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%20avatar%2C%20intellectual%20look%20with%20glasses%2C%20warm%20and%20approachable%2C%20clean%20solid%20light%20gray%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-04-user&orientation=squarish',
    time: '2 天前',
    content: '做影视内容创作的我经常需要查资料、看参考片，悟空影视的分类检索做得不错，按类型、按年份、按评分都能快速定位。内容覆盖面广，基本能满足我的素材需求。',
    score: 5,
  },
  {
    name: '大学僧小李',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20college%20student%20portrait%20avatar%2C%20bright%20energetic%20smile%2C%20youthful%20casual%20style%2C%20clean%20solid%20warm%20white%20background%2C%20natural%20lighting%20headshot&width=80&height=80&seq=avatar-05-user&orientation=squarish',
    time: '3 天前',
    content: '宿舍网速一般，但用悟空影视看剧意外地流畅！不像其他网站要缓冲半天。而且没有乱七八糟的弹窗广告，体验很清爽。全宿舍现在都用这个追剧了哈哈。',
    score: 4,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-1">
            用户怎么说
          </h2>
          <p className="text-sm text-foreground-500">来自真实用户的观影体验分享</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {comments.map((c, idx) => (
            <div
              key={idx}
              className="p-5 rounded-xl bg-background-100 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={c.avatar}
                    alt={c.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900">{c.name}</h3>
                  <span className="text-xs text-foreground-400">{c.time}</span>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-fill text-xs ${i < c.score ? 'text-accent-500' : 'text-foreground-200'}`}
                    ></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}